import React, { useState } from 'react'
import DeleteModal from '../../../components/Modal/DeleteModal'
import axios from 'axios'
import { apiKey } from '../../../config/config';
import { languageHelper } from "../../../config/helperFunctions";
import { toast } from "react-toastify";

function CleanDatabase() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const checkbox = [
    {
      id: "User",
      name: languageHelper("User Section"),
      value: "User"
    },
    {
      id: "Register",
      name: languageHelper("Register"),
      value: "Register"
    },
    {
      id: "Outlet",
      name: languageHelper("Outlet"),
      value: "Outlet"
    },
    {
      id: "Expense",
      name: languageHelper("Expense"),
      value: "Expense",
    },
    {
      id: "Customer",
      name: languageHelper("Customer"),
      value: "Customer",
    },
    {
      id: "Promotion",
      name: languageHelper("Promotion"),
      value: "Promotion"

    },
    {
      id: "Notifications",
      name: languageHelper("Notifications"),
      value: "Notifications",
    },
    {
      id: "Web Orders",
      name: languageHelper("Web Orders"),
      value: "Web Orders",
    },
    {
      id: "Deposit",
      name: languageHelper("Deposit"),
      value: "Deposit",
    },
    {
      id: "Returns",
      name: languageHelper("Returns"),
      value: "Returns",
    },
    {
      id: "Sales Items",
      name: languageHelper("Sales Items"),
      value: "Sales Items",
    },
    {
      id: "Food Menu Category",
      name: languageHelper("Food Menu Category"),
      value: "Food Menu Category",
    },
    {
      id: "Food Menu Items",
      name: languageHelper("Food Menu Items"),
      value: "Food Menu Items",
    },
    {
      id: "Purchases Items",
      name: languageHelper("Purchases Items"),
      value: "Purchases Items",
    },
    {
      id: "Add Ons",
      name: languageHelper("Add Ons"),
      value: "Add Ons",
    },
    {
      id: "Tables",
      name: languageHelper("Tables"),
      value: "Tables",
    },
    {
      id: "Ingredient Category",
      name: languageHelper("Ingredient Category"),
      value: "Ingredient Category",
    },
    {
      id: "Ingredients",
      name: languageHelper("Ingredients"),
      value: "Ingredients",
    },
    {
      id: "Units",
      name: languageHelper("Units"),
      value: "Units",
    },
    {
      id: "Subscription",
      name: languageHelper("Subscription"),
      value: "Subscription",
    },
    {
      id: "Hold Items",
      name: languageHelper("Hold Items"),
      value: "Hold Items",
    },
    {
      id: "Zatca",
      name: languageHelper("Zatca"),
      value: "Zatca",
    },
  ]

  const [selectedOption, setSelectedOption] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteAll, setDeleteAll] = useState(false);
  const [confirmSubmitModal, setConfirmSubmitModal] = useState(false);
  const [password, setPassword] = useState("");

  const handleSelect = (e) => {
    if (e.target.checked) {
      setSelectedOption([...selectedOption, e.target.value])
    } else {
      setSelectedOption(selectedOption.filter((item) => item !== e.target.value))
    }
  }

  const handleSubmit = (deleteAll = false) => {
    if (deleteAll) {
      axios.post(`${apiKey}/api/rms/admin/resetDB`, {
        password: password
      }, {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      }).then(res => {
        setConfirmSubmitModal(false);
        setDeleteModal(false);
        setSelectedOption([]);
        toast.success(res.data.message || "Data deleted successfully")
      }).catch(err => {
        toast.error(err.response.data.message || "Something went wrong")
      })
    } else {
      axios.post(`${apiKey}/api/rms/admin/delete_tables`, {
        password: password,
        tables: selectedOption
      }, {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      }).then(res => {
        setConfirmSubmitModal(false);
        setDeleteModal(false);
        setSelectedOption([]);
        toast.success(res.data.message || "Data deleted successfully")
      }).catch(err => {
        toast.error(err.response.data.message || "Something went wrong")
      })
    }
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div>
          <h1 className="text-[#7B20C7] text-2xl font-semibold py-5">{languageHelper("Clean Database")}</h1>
        </div>
        <div className="flex justify-end">
          <button onClick={() => { setDeleteAll(true); setDeleteModal(true) }} className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit">{languageHelper("Delete All Data")}</button>
        </div>
        <div className='flex flex-wrap  lg:flex-row gap-x-8 gap-y-4 w-full'>

          {checkbox &&
            checkbox.map((element) => (

              <div className="form-check w-full lg:w-1/5">
                <input className="form-check-input " type="checkbox" value={element.value} id={element.id} required onChange={handleSelect} />
                <label className="form-check-label pl-2 font-bold text-[#7B20C7]" for={element.id}>
                  {element.name}
                </label>
              </div>
            ))}

        </div>
        <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
        <div className="flex gap-2 pb-3">
          <button
            className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
            type="submit"
            onClick={() => { setDeleteAll(false); setDeleteModal(true) }}
          >
            {languageHelper("Submit")}
          </button>
        </div>
      </div>
      {
        deleteModal && (
          <DeleteModal
            setIsOpen={setDeleteModal}
            onDelete={() => setConfirmSubmitModal(true)}
          />
        )
      }{confirmSubmitModal && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-blur-md grid place-items-center z-50"
          onClick={() => {setConfirmSubmitModal(false); setPassword("")}}  
        >
          <div
            className="bg-white rounded p-6 w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(deleteAll);
              }}
            >
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Password")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="password"
                    name="password"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={languageHelper("Password")}
                    value={password}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
              <div className="flex justify-between mt-4">
                <button
                  className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                  type="submit"
                // disabled={loading}
                >
                  {/* {loading && (
                    <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                      <img
                        className="w-4 mx-auto"
                        src="/assets/gif/button_loader.gif"
                        alt=""
                      />
                    </span>
                  )} */}
                  {languageHelper("Submit")}
                </button>
                <button
                  className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                  type="button"
                  onClick={() => {setConfirmSubmitModal(false); setPassword("")}}  
                >
                  {languageHelper("Cancel")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </main>
  )
}

export default CleanDatabase
